export let basicData = {
    colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',
   '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],
    chart: {
        type: 'spline'
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    xAxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    yAxis: {
        title: {
            text: 'EA'
        },
        labels: {
            formatter: function () {
                return this.value + '';
            }
        }
    },
    tooltip: {
        crosshairs: true,
        shared: true
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        spline: {
            marker: {
                radius: 4,
                lineColor: '',
                lineWidth: 1
            }
        }
    },
    series: [
        {
            name: 'Type A',
            marker: {
                symbol: 'round',
            },
            data: [710, 699, 954, 1450, 1820, 2150, 2522, 2644, 2331, 1839, 1389, 960]
        },
        {
            name: 'Type B',
            marker: {
                symbol: 'square'
            },
            data: [320, 330, 450, 480, 480, 540, 540, 720, 960, 1280, 720, 640]
        },
        {
            name: 'Type C',
            marker: {
                symbol: 'diamond'
            },
            data: [1280, 1024, 768, 640, 480, 320, 240, 160, 240, 320, 640, 768]
        },
    ]
};

export let asyncData = {
    name: 'Tokyo',
    marker: {
        symbol: 'square'
    },
    data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, {
        y: 26.5,
        marker: {
            symbol: 'url(http://www.highcharts.com/demo/gfx/sun.png)'
        }
    }, 23.3, 18.3, 13.9, 9.6]
}


// area chart data
export const AreaData = {
    colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',
   '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],    
    chart: {
        type: 'area'
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    xAxis: {
        allowDecimals: false,
        labels: {
            formatter: function () {
                return this.value; // clean, unformatted number for year
            }
        }
    },
    yAxis: {
        title: {
            text: '발생빈도'
        },
        labels: {
            formatter: function () {
                return this.value / 1000 + '';
            }
        }
    },
    credits: {
        enabled: false
    },
    tooltip: {
       // pointFormat: '{series.name} produced <b>{point.y:,.0f}</b><br/>warheads in {point.x}'
    },
    plotOptions: {
        area: {
            pointStart: 10,
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true
                    }
                }
            }
        }
    },
    series: [{
        name: 'Type A',
        data: [null, null, null, null, null, 6, 11, 32, 110, 235, 369, 640,
            1005, 1436, 2063, 3057, 4618, 6444, 9822, 15468, 20434, 24126,
            27387, 29459, 31056, 31982, 32040, 31233, 29224, 27342, 26662,
            26956, 27912, 28999, 28965, 27826, 25579, 25722, 24826, 24605,
            24304, 23464, 23708, 24099, 24357, 24237, 24401, 24344, 23586,
            22380, 21004, 17287, 14747, 13076, 12555, 12144, 11009, 10950,
            10871, 10824, 10577, 10527, 10475, 10421, 10358, 10295, 10104]
    }, {
        name: 'Type B',
        data: [null, null, null, null, null, null, null, null, null, null,
            5, 25, 50, 120, 150, 200, 426, 660, 869, 1060, 1605, 2471, 3322,
            4238, 5221, 6129, 7089, 8339, 9399, 10538, 11643, 13092, 14478,
            15915, 17385, 19055, 21205, 23044, 25393, 27935, 30062, 32049,
            33952, 35804, 37431, 39197, 45000, 43000, 41000, 39000, 37000,
            35000, 33000, 31000, 29000, 27000, 25000, 24000, 23000, 22000,
            21000, 20000, 19000, 18000, 18000, 17000, 16000]
    }]
}

// pie chart data
export const PieData = {    
    chart: {
        type: 'pie',
        options3d: {
            enabled: false,
            alpha: 45
        }
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        pie: {
            innerSize: 100,
            depth: 45
        }
    },
    series: [{
        name: '발견건수',
        data: [
            ['Linearity', 8],
            ['Inking', 3],
            ['Air Gap', 1],
            ['Overcured', 6],
            ['Carbonization', 8],
            ['Wave', 4],
            ['Curl', 4],
            ['Cratering', 1],
            ['Swaging', 1]
        ]
    }]
}
// Bar chart data
export const BarData = {
    colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',
        '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],  
    chart: {
        type: 'bar',
    },
    title: {
        text: '',
    },
    subtitle: {
        text:'',
    },
    xAxis: {
        categories: ['P1', 'P2', 'P3', 'P4', 'P5'],
        title: {
        text: null,
        },
    },
    yAxis: {
        min: 0,
        title: {
        text: 'EA',
        align: 'middle',
        },
        labels: {
        overflow: 'justify',
        },
    },
    tooltip: {
        valueSuffix: ' ea',
    },
    plotOptions: {
        bar: {
        dataLabels: {
            enabled: true,
        },
        },
    },
    legend: {

    },
    credits: {
        enabled: false,
    },
    series: [
        {
        name: 'Type A',
        data: [107, 31, 635, 203, 2],
        },
        {
        name: 'Type B',
        data: [133, 156, 947, 408, 6],
        },
        {
        name: 'Type C',
        data: [1052, 954, 4250, 740, 38],
        },
    ], 
}

export const DrilldownData = {
    chart: {
        type: 'column'
    },
    title: {
        text: 'Basic drilldown'
    },
    xAxis: {
        type: 'category'
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            dataLabels: {
                enabled: true
            }
        }
    },
    series: [{
        name: 'Things',
        colorByPoint: true,
        data: [{
            name: 'Animals',
            y: 5,
            drilldown: 'animals'
        }, {
            name: 'Fruits',
            y: 2,
            drilldown: 'fruits'
        }, {
            name: 'Cars',
            y: 4,
            drilldown: 'cars'
        }]
    }],
    drilldown: {
        series: [{
            id: 'animals',
            data: [
                ['Cats', 4],
                ['Dogs', 2],
                ['Cows', 1],
                ['Sheep', 2],
                ['Pigs', 1]
            ]
        }, {
            id: 'fruits',
            data: [{
                name: 'Apples',
                y: 4
            }, {
                name: 'Oranges',
                y: 2,
                drilldown: 'third-leves'
            }]
        }, {
            id: 'cars',
            data: [
                ['Toyota', 4],
                ['Opel', 2],
                ['Volkswagen', 2]
            ]
        }, {
            id: 'third-leves',
            data: [
                ['Toyota', 4],
                ['Opel', 2],
                ['Volkswagen', 2]
            ]
        }]
    }
};

// Scatter chart data

var surfaceData = [],
    innerData = []

    for (let i = 0; i < 6800; i += 1) { 
    /*    let obj = {
                x:'',
                y:'',
                z:'',
            }
        obj.x = parseInt(Math.pow(Math.random(), 1.2) * 2500),
        obj.y = parseInt(Math.pow(Math.random(), 1.2) * 2500),
        obj.z = Math.floor(Math.random() * (-1000)) + -1000
        data.push(obj) */
        
        surfaceData.push([
            parseInt(Math.pow(Math.random(), 1.2) * 2500),
            parseInt(Math.pow(Math.random(), 1.2) * 2500),
           // Math.floor(Math.random() * (-1000))
        ])
    }

    for (let i = 0; i < 200; i += 1) { 
        innerData.push([
            parseInt(Math.pow(Math.random(), 2) * 2200),
            parseInt(Math.pow(Math.random(), 2) * 2200),
        ])
    }

export const ScatterData = {
    chart: {
        type: 'scatter',
        zoomType: 'xy',
        height: '100%',
    },
    credits: {
        enabled: false
    },
    turboThreshold: 10000,
    boost: {
        useGPUTranslations: true,
        usePreAllocated: true
    },
    xAxis: {
        min: 0,
        //max: 100,
        gridLineWidth: 1
    },
    yAxis: {
        // Renders faster when we don't have to compute min and max
        min: 0,
        //max: 100,
        minPadding: 0,
        maxPadding: 0,
        title: { text: null }
    },
    title: {
        text: '  '
    },
    legend: {
        enabled: true
    },
    series: [{
        name: 'Surface',
        color: '#006cb7',
        data: surfaceData,
        marker: {
            radius: 1.8
        },
        tooltip: {
            followPointer: false,
            //pointFormat: 'X: {point.x}<br />Y: {point.y}<br />Z: {data[0]:.1f}'
            //pointFormat: '[{point.x:.1f}, {point.y:.1f}]'
        }
    },
    {
        name: 'Inner',
        color: '#ce0f42',
        data: innerData,
        marker: {
            radius: 1.8
        },
        tooltip: {
            followPointer: false,
            //pointFormat: 'X: {point.x}<br />Y: {point.y}<br />Z: {data[0]:.1f}'
            //pointFormat: '[{point.x:.1f}, {point.y:.1f}]'
        }
    }]
}